import React from "react";

import {
  TabControl,
  TabItem,
  Checkbox,
  Button,
} from "@abb/abb-common-ux-react";
import { Dropdown, DropdownOption } from "@abb/abb-common-ux-react";
import AbbTableComponent from "../shared/AbbTableComponent";
import * as CONSTANTS from "../../utilities/Constants";
import { Input, WithTooltip, Tooltip, Icon } from "@abb/abb-common-ux-react";
import { ILogViewData } from "../../models/logs/LogViewData";
import { Translation } from "react-i18next";
import { DatePicker, Space } from "antd";
import DateFormatting from "../../utilities/DateFormat";
import moment from "moment";
import History from "../../utilities/History";
import { CSVLink } from "react-csv";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingState {
  activeTab: number;
  items: Array<any>;
}
interface ILandingProperties {
  logsData: ILogViewData[];
  reducedArray: any;
  moduleDropdownList: any[];
  selectedDateRange: any[];
  dateRangeHandler: (value: any) => void;
  selectFromDate: string;
  selectToDate: string;
  setTrendCustomFromDate: (value: any) => void;
  setTrendCustomToDate: (value: any) => void;
  selectedModule: any[];
  moduleChangeHandler: (value: any) => void;
  searchInput: string;
  searchInputChangeHandler: (value: any) => void;
}

class Landing extends React.Component<ILandingProperties, ILandingState> {
  headers = [
    { label: "ID", key: "id" },
    { label: "Time Stamp", key: "timeStamp" },
    { label: "Message", key: "message" },
    { label: "Exception", key: "exception" },
    { label: "Level", key: "level" },
    { label: "User Name", key: "userName" },
    { label: "Module", key: "module" },
  ];
  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: 0,
      items: ["All Features", "Instrument", "Product", "Product QA"],
    };
  }
  public tableComponent = (logsData: ILogViewData[]) => {
    return (
      <AbbTableComponent
        columns={[
          {
            dataField: "id",
            text: "ID",
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
            isFixed: false
          },
          {
            dataField: "timeStamp",
            text: "Timestamp",
            headerStyle: (colum, colIndex) => {
              return { width: "15%" };
            },
            isFixed: false
          },
          {
            dataField: "message",
            text: "Message",
            headerStyle: (colum, colIndex) => {
              return { width: "30%", textAlign: "left" };
            },
            isFixed: false
          },
          {
            dataField: "exception",
            text: "Exception",
            headerStyle: (colum, colIndex) => {
              return { width: "30%" };
            },
            isFixed: false
          },
          {
            dataField: "level",
            text: "Level",
            headerStyle: (colum, colIndex) => {
              return { width: "10%", textAlign: "left" };
            },
            isFixed: false
          },
          {
            dataField: "userName",
            text: "Username",
            headerStyle: (colum, colIndex) => {
              return { width: "15%", textAlign: "left" };
            },
            isFixed: false
          },
          {
            dataField: "module",
            text: "Module",
            headerStyle: (colum, colIndex) => {
              return { width: "10%", textAlign: "left" };
            },
            isFixed: false
          },
        ]}
        select={false}
        list={logsData}
        isFixedColumn={false} />
    )
  }

  public getFileName = () => {
    let d = new Date();
    return "lmslogs-" + d + ".csv";
  }

  public noLogsFound = (data: string) => {
    return (
      <div style={{ textAlign: "center", padding: "10px 0 0 0" }}>
        {`No ${data} Logs Found`}
      </div>
    )
  }

  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  private _datetimeFormat = "YYYY-MM-DD HH:mm:ss";
  private daterange = CONSTANTS.DATE_RANGES;

  public render() {
    const commonProp = {
      activeTab: this.state.activeTab,
      onTabChange: (oldIndex: any, newIndex: any) =>
        this.setState({ activeTab: newIndex }),
    };
    return (
      <Translation>
        {(t) => (
          <div className="page-layout dashboard-layout">
            <div className="row">
              <div className="col-xl-2">
                <div className="row w-100">
                  <Input
                    type="discreet"
                    dataType="text"
                    placeholder={t("Search")}
                    icon="abb/search"
                    value={this.props.searchInput}
                    onValueChange={this.props.searchInputChangeHandler}
                  />
                </div>
                <div className="row w-100">
                  <div className="col-sm col-md w-100" style={{ padding: 0 }}>
                    <Dropdown
                      className="w-100"
                      label={t(CONSTANTS.LABEL_DATE_MODIFIED)}
                      allowAdd={false}
                      clearable={false}
                      placeholder={t(CONSTANTS.LABEL_SELECT)}
                      value={this.props.selectedDateRange}
                      onChange={this.props.dateRangeHandler}
                    >
                      {this.daterange.map((o: any) => (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      ))}
                    </Dropdown>
                  </div>
                </div>
                {this.props.selectedDateRange[0]?.value === 4 && (
                  <div>
                    <div className="row w-100 trend">
                      <div className="col-sm col-md" style={{ padding: "0" }}>
                        <div className="custom-label">
                          {t(CONSTANTS.FROM)}
                        </div>
                        <Space direction="vertical" size={12}>
                          <DatePicker
                            format={
                              DateFormatting.getDateTimeRegion() ||
                              "DD-MM-YYYY hh:mm A"
                            }
                            showTime={{
                              use12Hours: true,
                              format: "hh:mm A",
                            }}
                            defaultValue={
                              this.props.selectFromDate
                                ? moment(this.props.selectFromDate)
                                : null
                            }
                            onChange={this.props.setTrendCustomFromDate}
                            onOk={this.props.setTrendCustomFromDate}
                            allowClear={true}
                            bordered={true}
                            placeholder={
                              DateFormatting.getDateTimeRegion() ||
                              "DD-MM-YYYY hh:mm A"
                            }
                          />
                        </Space>
                      </div>
                    </div>
                    <div className="row w-100 trend">
                      <div className="col-sm col-md" style={{ padding: "0" }}>
                        <div className="custom-label">
                          {t(CONSTANTS.TO)}
                        </div>
                        <Space direction="vertical" size={12}>
                          <DatePicker
                            format={
                              DateFormatting.getDateTimeRegion() ||
                              "DD-MM-YYYY hh:mm A"
                            }
                            showTime={{
                              use12Hours: true,
                              format: "hh:mm A",
                            }}
                            defaultValue={
                              this.props.selectToDate
                                ? moment(this.props.selectToDate)
                                : null
                            }
                            onChange={this.props.setTrendCustomToDate}
                            onOk={this.props.setTrendCustomToDate}
                            allowClear={true}
                            bordered={true}
                            placeholder={
                              DateFormatting.getDateTimeRegion() ||
                              "DD-MM-YYYY hh:mm A"
                            }
                            dropdownClassName="dropdown_class_name_1"
                          />
                        </Space>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row w-100">
                  <Dropdown
                    className="w-100"
                    label={t("Module")}
                    allowAdd={false}
                    clearable={false}
                    multiselect={false}
                    searchable={false}
                    placeholder={"Module"}
                    value={this.props.selectedModule}
                    onChange={this.props.moduleChangeHandler}
                  >
                    {this.props.moduleDropdownList?.map(
                      (o: { value: React.Key; label: string }) => (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      )
                    )}
                  </Dropdown>
                </div>
              </div>

              <div className="col-xl-10">
                {renderBreadcrumb(
                  [
                    { text: t("Home"), link: "/samplenew", bolder: false },
                    { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                    { text: t(CONSTANTS.SUBMENU_LOGS), link: null, bolder: true }
                  ], "pl-3 pb-3")
                }
                <div className="summary-layout">
                  <div className="summary pb-2">
                    <div className="d-flex" style={{ width: "100%", alignItems: "center" }}>
                      <div className="summary-text" style={{ width: "50%" }}>{t("Logs")}</div>
                      <p className="download-logs">
                        <CSVLink data={this.props.logsData}
                          headers={this.headers}
                          filename={this.getFileName()}
                        >
                          <div><button
                            title={t(CONSTANTS.MENU_DOWNLOAD_LOGS)}
                            className="color-black"
                            disabled={this.props.logsData.length !== 0 ? false : true}
                          >
                            <Icon name="abb/download"
                              sizeClass="medium"
                            />
                          </button></div>
                        </CSVLink></p></div>
                    <div className="header-underline"></div>
                    <div className="mt-2 tab-area mx-3">
                      <TabControl
                        type="primary"
                        {...commonProp}
                        activeTab={this.state.activeTab}
                      >
                        <TabItem key={1} title={t("All Features")}>
                          <div className="border" style={{ paddingBottom: "1em" }}>
                            {(this.props.logsData && this.props.logsData.length !== 0) ?
                              this.tableComponent(this.props.logsData) :
                              this.noLogsFound("")}
                          </div>
                        </TabItem>
                        <TabItem key={2} title={t("Warning")}>
                          <div className="border" style={{ paddingBottom: "1em" }}>
                            {this.props.reducedArray["Warning"] ?
                              this.tableComponent(this.props.reducedArray["Warning"]) :
                              this.noLogsFound("Warning")}
                          </div>
                        </TabItem>
                        <TabItem key={3} title={t("Error")}>
                          <div className="border" style={{ paddingBottom: "1em" }}>
                            {this.props.reducedArray["Error"] ?
                              this.tableComponent(this.props.reducedArray["Error"]) :
                              this.noLogsFound("Error")}
                          </div>
                        </TabItem>
                        <TabItem key={4} title={t("Debug")}>
                          <div className="border" style={{ paddingBottom: "1em" }}>
                            {this.props.reducedArray["Debug"] ?
                              this.tableComponent(this.props.reducedArray["Debug"]) :
                              this.noLogsFound("Debug")}
                          </div>
                        </TabItem>
                        <TabItem key={5} title={t("Information")}>
                          <div className="border" style={{ paddingBottom: "1em" }}>
                            {this.props.reducedArray["Information"] ?
                              this.tableComponent(this.props.reducedArray["Information"]) :
                              this.noLogsFound("Information")}
                          </div>
                        </TabItem>
                      </TabControl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default Landing;
